<template>
  <div class="module-rules-form-buttons">
    <template v-if="!ruleId">
      <UICheckbox v-model="modelValue" :disabled="controlDisabled" label="Apply to future only" />
      <UIButton label="Create" :disabled="controlDisabled" :loading data-refid="createRuleButton" @click="handleCreate" />
    </template>
    <template v-else>
      <template v-if="disabled && !prefilled">
        <div />
        <UIButton
          label="Apply to historic"
          :loading
          :disabled="loading"
          class="order-4 sm:order-none"
          @click="handleApply"
        />
      </template>
      <template v-else>
        <UICheckbox v-model="modelValue" :disabled="controlDisabled" label="Apply to future only" />
        <UIButton label="Save" :disabled="controlDisabled" :loading @click="handleUpdate" />
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { UICheckbox } from '@ui/controllers'
import { UIButton } from '@ui/buttons'

type Props = {
  ruleId?: string
  disabled: boolean
  prefilled?: boolean
  loading?: boolean
}

type Emits = {
  create: []
  apply: []
  update: []
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const modelValue = defineModel<boolean>('modelValue')

const controlDisabled = computed(() => props.disabled || props.loading)

const handleCreate = () => {
  emit('create')
}

const handleApply = () => {
  emit('apply')
}

const handleUpdate = () => {
  emit('update')
}
</script>

<style>
.module-rules-form-buttons {
  @apply flex flex-col sm:flex-row items-center justify-end;
  @apply gap-2 sm:gap-4;
  @apply order-last sm:order-none;

  .module-rules__buttons & {
    @apply w-full sm:w-auto;
  }

  > .ui-button {
    @apply w-full sm:w-auto;
  }
}
</style>
